import { useChatClass } from "../../theme";
import { ANIMATION_DURATION, Container, Dot } from "./styled";

const ANIMATION_DELAY = Math.floor(ANIMATION_DURATION / 3);

interface TypingIndicatorComponent extends React.FC {
  Container: typeof Container;
  Dot: typeof Dot;
}

/** An animated indicator to show that the system is preparing a response. */
const TypingIndicator: TypingIndicatorComponent = () => {
  const chatClass = useChatClass();
  return (
    <Container className={chatClass("typing-indicator")}>
      {Array.from({ length: 3 }).map((_, index) => (
        <Dot $animationDelayMs={ANIMATION_DELAY * (index + 1)} key={index} />
      ))}
    </Container>
  );
};

TypingIndicator.Container = Container;
TypingIndicator.Dot = Dot;

export { TypingIndicator };
